// RenderOrderDetails.jsx
import React, { useState } from 'react'
import RenderProductOrder from '../render/RenderProductOrder';
import { useSelector } from 'react-redux';
import Loader from '../../components/Loader';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SettingIconBlock from './../../components/Button/SettingIconBlock';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddOrderProducts from './AddOrderProducts';
import TotalAmountContainer from './TotalAmountContainer';
import ContainerModalConfirmPlusIcon from './ContainerModalConfirmPlusIcon';
import OrderDetailsButton from './OrderDetailsButton';

const RenderOrderDetails = ({
    setShowDeletingConfirmation,
    setShowPaymentAccountModal,
    showDeletingConfirmation,
    setShowSettingEditModal,
    confirmVisibleOrderById,
    handleShowSettingModal,
    handleTotalAmount,
    typeEditOrderModal,
    showOrderModal,
    handleShowEditOrderModal,
    confirmDelete,
    setClicked,
    orderDetails,
    clicked,
    index,
}) => {

    const user = useSelector((state) => state.user.userDetails)

    const [showVisibleConfirm, setShowVisibleConfirm] = useState(false)

    const orderItems = Array.isArray(orderDetails?.items) ? orderDetails.items : [];

    const totalAmount = () => orderItems.reduce((obj, key) => {
        const bayerPrice = Number(key?.bayerPrice) || 0;
        const purchasedQty = Number(key?.purchasedQty) || 0;

        return obj + bayerPrice * purchasedQty;
    }, 0);

    if (!user) return <Loader />

    return (
        <div
            className="renderOrderDetails"
            onClick={e => e.stopPropagation()}
        >
            {clicked === index ? (
                <div className="container">
                    <div className="row">
                        <div className="col-sm-4">
                            <p>Информация о Заказчике</p>
                            <div className="m-2 p-1">
                                <div>{user?.firstName} {user?.lastName}</div>
                                <div>{user?.contactNumber ? user.contactNumber : "Номер не указан"}</div>
                                <div>{user?.email}</div>
                            </div>

                            <OrderDetailsButton
                                setShowSettingEditModal={setShowSettingEditModal}
                                label="История заказа"
                                type=""
                                onClick={() => showOrderModal("")}
                                handleShowEditOrderModal={handleShowEditOrderModal}
                                typeEditOrderModal={typeEditOrderModal}
                            />

                            <OrderDetailsButton
                                setShowSettingEditModal={setShowSettingEditModal}
                                label="Адрес доставки"
                                type="address"
                                onClick={() => showOrderModal("address")}
                                handleShowEditOrderModal={handleShowEditOrderModal}
                                typeEditOrderModal={typeEditOrderModal}
                            />

                            <OrderDetailsButton
                                setShowSettingEditModal={setShowSettingEditModal}
                                label="Способ доставки"
                                isDisabled={orderDetails?.deliveryId === undefined || orderDetails?.deliveryId === null}
                                onClick={() => orderDetails?.deliveryId !== undefined && orderDetails?.deliveryId !== null && showOrderModal("deliveryId")}
                                settingIcon
                                type="deliveryId"
                                handleShowEditOrderModal={handleShowEditOrderModal}
                                typeEditOrderModal={typeEditOrderModal}
                            />

                            <OrderDetailsButton
                                setShowSettingEditModal={setShowSettingEditModal}
                                label="Способы оплаты"
                                isDisabled={orderDetails?.paymentId === undefined || orderDetails?.paymentId == null}
                                onClick={() => orderDetails?.paymentId !== undefined && orderDetails?.paymentId !== null && showOrderModal("paymentId")}
                                settingIcon
                                type="paymentId"
                                handleShowEditOrderModal={handleShowEditOrderModal}
                                typeEditOrderModal={typeEditOrderModal}
                            />

                            <OrderDetailsButton
                                setShowSettingEditModal={setShowSettingEditModal}
                                label="Точка самовывоза"
                                isDisabled={orderDetails?.pickupPointsId === undefined || orderDetails?.pickupPointsId == null}
                                onClick={() => orderDetails?.pickupPointsId !== undefined && orderDetails?.pickupPointsId !== null && showOrderModal("pickupPointsId")}
                                settingIcon
                                type="pickupPointsId"
                                handleShowEditOrderModal={handleShowEditOrderModal}
                                typeEditOrderModal={typeEditOrderModal}
                            />

                            {orderDetails?.orderOnOperator && (
                                <div className="renderOrderDetails__orderOnOperator">
                                    <span>Заказчик предпочел, чтобы оператор более детально изучил вопрос с доставкой.</span>
                                </div>
                            )}

                            {orderDetails?.paymentOrderOnOperator && (
                                <div className="renderOrderDetails__orderOnOperator">
                                    <span>Заказчик предпочел, чтобы оператор более детально изучил вопрос с оплатой.</span>
                                </div>
                            )}
                        </div>

                        <div className="col-sm-8 renderOrderDetails__contentItemsBox">
                            <div className="renderOrderDetails__titleContainer">
                                <span className="title">Товары Нашего производства</span>
                                <div className="renderOrderDetails__settingIconBlock">
                                    <SettingIconBlock
                                        tooltip="Список оплаты"
                                        icon={<AccountBalanceWalletIcon />}
                                        top="20px"
                                        right="20px"
                                        onClick={() => setShowPaymentAccountModal(true)}
                                    />

                                    {orderDetails?.disableFunctionality ? null : (
                                        <ContainerModalConfirmPlusIcon
                                            tooltip={`${orderDetails?.visibleOrder?.isCompleted ? "Добавить заказ в скрытые" : "Востановить заказ"}`}
                                            top="20px"
                                            right="40px"
                                            icon={<VisibilityIcon />}
                                            onClickShow={() => setShowVisibleConfirm(true)}
                                            title={`${orderDetails?.visibleOrder?.isCompleted ? "Подтвердить добавление заказа в скрытые" : "Подтвердить востановление заказа"}`}
                                            description="Если действиетельно хотите подтвердить действие то нажмите 'Продолжить' "
                                            show={showVisibleConfirm}
                                            handleClose={() => setShowVisibleConfirm(false)}
                                            onClick={confirmVisibleOrderById}
                                        />
                                    )}

                                    {orderDetails?.disableFunctionality ? null : (
                                        <ContainerModalConfirmPlusIcon
                                            tooltip="Удалить заказ"
                                            top="20px"
                                            right="60px"
                                            icon={<DeleteIcon />}
                                            onClickShow={() => setShowDeletingConfirmation(true)}
                                            title={`Подтвердить удаление заказа ${orderDetails?._id || ""}`}
                                            description="Если вы продолжите то вернуть его будет невозможно!!!"
                                            show={showDeletingConfirmation}
                                            handleClose={() => setShowDeletingConfirmation(false)}
                                            onClick={() => confirmDelete(orderDetails?._id)}
                                        />
                                    )}
                                </div>
                            </div>

                            <div className="renderOrderDetails__productOrderContainer">
                                {orderItems.map((productItem, productIndex) => {
                                    const key = productItem?._id || productItem?.productId?._id || productIndex;

                                    if (!productItem?.productId) {
                                        return (
                                            <div
                                                className="renderOrderDetails__missingProduct"
                                                key={key}
                                            >
                                                Товар удалён или не найден
                                            </div>
                                        )
                                    }

                                    return (
                                        <RenderProductOrder
                                            orderDetails={orderDetails}
                                            handleShowSettingModal={handleShowSettingModal}
                                            key={key}
                                            productItem={productItem}
                                        />
                                    )
                                })}
                            </div>

                            <AddOrderProducts
                                setClicked={setClicked}
                                orderItem={orderDetails}
                            />

                            <TotalAmountContainer
                                totalAmount={totalAmount}
                                handleTotalAmount={(amount) => handleTotalAmount(amount, orderDetails?._id)}
                                orderItem={orderDetails}
                            />
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default RenderOrderDetails